import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Wrap,
  WrapItem,
  Button,
  useColorMode,
  Divider,
  Box,
  Heading,
  Text,
  Flex,
} from "@chakra-ui/react"
import {
  useIntl,
  Link,
  changeLocale,
  FormattedMessage,
} from "gatsby-plugin-intl"
import logo from "../img/headerlogo.png"
import logoW from "../img/headerlogo-w.png"
import footerlogo from "../img/footerlogo.png"
import hamburger from "../img/menu.png"
import hamburgerW from "../img/menu-white.png"

const Layout = ({ children, container }) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const { colorMode, toggleColorMode } = useColorMode()
  const intl = useIntl()
  const intlIsNo = intl.locale === "no"
  const isLight = colorMode === "light"
  // eslint-disable-next-line
  const rootPath = `${__PATH_PREFIX__}/`

  const menu = [
    { label: <FormattedMessage id="headerMenuBikes" />, link: "/bikes" },
    { label: <FormattedMessage id="headerMenuBuy" />, link: "/info" },
    { label: <FormattedMessage id="headerMenuContact" />, link: "/contact" },
    { label: "Bikefinder", link: "/bikefinder" },
  ]

  return (
    <>
      <header className="sc-header">
        <div>
          <Link to="/">
            <img className="header-logo" src={isLight ? logo : logoW} />
          </Link>
        </div>
        <div className="sc-nav-menu">
          {menu.map(item => (
            <Link
              key={item.label}
              to={item.link}
              activeClassName="sc-nav-menu-item-active"
            >
              {item.label}
            </Link>
          ))}
        </div>
        <div className="sc-nav-menu-mobile">
          <button onClick={() => setMenuOpen(!menuOpen)}>
            <img src={isLight ? hamburger : hamburgerW} alt="Menu"></img>
          </button>
          {menuOpen && (
            <>
              <div
                className="menu-dialog-backdrop"
                onClick={() => setMenuOpen(false)}
              />
              <div className="menu-dialog-wrapper">
                <div
                  className="menu-dialog"
                  style={{ backgroundColor: "white" }}
                >
                  {menu.map(item => (
                    <Link
                      key={item.label}
                      to={item.link}
                      activeClassName="sc-nav-menu-item-active"
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      </header>

      <div className="sc-content-wrapper">
        <div className={`sc-content ${container ? "container" : ""}`}>
          {/* <SlideFade in> */}
          <main>{children}</main>
          {/* </SlideFade> */}
        </div>
      </div>

      <footer
        className="sc-footer-wrapper"
        style={{ background: isLight ? "#cada2f" : "#788316" }}
      >
        <Flex className="sc-footer">
          <Wrap flex="1" p="5" justifyContent="center">
            <WrapItem p="5" w="300px">
              <img style={{ maxWidth: "200px" }} src={footerlogo} />
            </WrapItem>
            <WrapItem p="5" w="300px">
              <Box>
                <Heading size="md">
                  <FormattedMessage id="footerTermsHeader" />
                </Heading>
                <Divider marginTop="2" marginBottom="3" />
                <Text>
                  <Link to="/privacy">
                    <FormattedMessage id="footerPrivacy" />
                  </Link>
                </Text>
              </Box>
            </WrapItem>
            <WrapItem p="5" w="300px">
              <Box>
                <Heading size="md">
                  <FormattedMessage id="footerAboutUs" />
                </Heading>
                <Divider marginTop="2" marginBottom="3" />
                <Text>SCUSHI Trondheim AS</Text>
                <Text>Org.nr. 817 483 712</Text>
                <Text>
                  <a
                    href="https://scushi-elsykkel.no"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "underline" }}
                  >
                    <FormattedMessage id="footerVisitHomePage" />
                  </a>
                </Text>
              </Box>
            </WrapItem>
            <WrapItem p="5" w="300px">
              <Box>
                <Heading size="md">
                  <FormattedMessage id="footerOptions" />
                </Heading>
                <Divider marginTop="2" marginBottom="3" />
                <Button marginBottom="2" w="150px" onClick={toggleColorMode}>
                  {isLight ? (
                    <FormattedMessage id="footerDarkMode" />
                  ) : (
                    <FormattedMessage id="footerLightMode" />
                  )}
                </Button>

                <Button
                  w="150px"
                  onClick={() => changeLocale(intlIsNo ? "en" : "no")}
                >
                  {intlIsNo ? "Switch to english" : "Bytt til norsk"}
                </Button>
              </Box>
            </WrapItem>
          </Wrap>
        </Flex>
        <Box textAlign="center" marginTop="5">
          {`© SCUSHI Elsykkel ${new Date().getFullYear()}`}
        </Box>
      </footer>
    </>
  )
}

Layout.propTypes = {
  location: PropTypes.object,
  children: PropTypes.node,
  container: PropTypes.boolean,
}

export default Layout
